
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ChildrenHero = () => {
  return (
    <section className="relative bg-gradient-to-r from-piano-black to-gray-900 text-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6">
              Klaverundervisning for børn
            </h1>
            <p className="text-xl text-gray-300 mb-6">
              Giv dit barn en livslang gave gennem engagerende og sjov klaverundervisning. Min tilgang til børn er legende, tålmodig og fokuseret på at skabe en positiv oplevelse med musik.
            </p>
            <div className="space-y-4">
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">1</span>
                <p>Sjove og alderssvarende øvelser og melodier</p>
              </div>
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">2</span>
                <p>Legende tilgang til musikalske grundbegreber</p>
              </div>
              <div className="flex items-center">
                <span className="bg-piano-gold rounded-full w-8 h-8 flex items-center justify-center mr-3 text-black font-bold">3</span>
                <p>Udvikling af koncentration og koordination</p>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-piano-gold hover:bg-piano-gold/90 text-black font-semibold">
                <Link to="/kontakt#top">Book gratis prøvetime</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-white text-black hover:bg-white/10">
                <Link to="/undervisning#top" className="flex items-center">
                  Se alle muligheder <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
          <div className="relative">
            <div className="bg-piano-gold/10 rounded-lg p-2 md:p-4">
              <img 
                src="/lovable-uploads/3498deda-3d45-422b-bce5-7a5717ed23da.png" 
                alt="Klaverundervisning for børn" 
                className="rounded-lg object-cover max-h-96 w-full"
                loading="eager"
                width={800}
                height={600}
              />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-white text-black p-4 rounded-lg shadow-lg max-w-xs hidden md:block">
              <p className="font-semibold text-sm">
                "Som far til fire børn ved jeg, hvordan man gør læring sjov og engagerende for selv de yngste musikelever."
              </p>
              <p className="text-sm mt-2 text-gray-600">- Oscar Gilbert, Pianist</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChildrenHero;
